export const blockIconsMapsPinDrop = (
	<span className='material-symbols-outlined'>pin_drop</span>
);
